(ns app.domain.blackout.model
  (:require #?(:clj [app.domain.blackout.query :as blackout-query])
            #?(:cljs [core.front.date-util :as date-util])
            [app.domain.group.model :as group-model]
            [app.i18n.model :as i18n-model]
            [core.db.child-entity :as child])
  #?(:clj (:import [java.util Date])))


(def blackout-subtypes [:blackout.subtype/general
                        :blackout.subtype/inspection])


(def ^{:arglists '([authority-group])} group-blackouts
  (child/child-entities-of-type-fn :entity.type/blackout))

(defmethod group-model/get-authority-group :entity.type/blackout [blackout]
  ;; Blackouts of domain and superdomain groups have no single authority group
  (let [parent (:entity/parent blackout)]
    (when (group-model/application-or-upper-tier-authority? parent)
      parent)))


(defn current-group-blackouts
  ([authority-group]
   (current-group-blackouts authority-group nil))
  ([authority-group ending-after-date]
   #?(:clj  (let [date (or ending-after-date (Date.))]
              (if (group-model/superdomain-calendar? authority-group)
                (blackout-query/current-group-blackouts (group-model/group-superdomain authority-group) date)
                (blackout-query/current-group-blackouts authority-group date)))
      :cljs (let [date-fn #(<= (or ending-after-date (js/Date.)) (:blackout/end-time %))]
              (if (group-model/superdomain-calendar? authority-group)
                (->> (group-blackouts (group-model/group-superdomain authority-group))
                     (filter date-fn))
                (->> (group-blackouts authority-group)
                     (filter date-fn)))))))


(defn ^:dynamic current-group-general-blackouts
  "Return only the upcoming general blackouts, e.g. public holidays"
  ([authority-group]
   (current-group-general-blackouts authority-group #?(:clj (Date.) :cljs (js/Date.))))
  ([authority-group ending-after]
   (->> (current-group-blackouts authority-group ending-after)
        (filter #(-> % :blackout/subtype (= :blackout.subtype/general))))))


#_{:clj-kondo/ignore #?(:clj [:unused-binding] :cljs [])}
(defn localize-blackouts
  "Convert blackout boundaries to the browser's local representation for `timezone`."
  [blackouts timezone]
  #?(:clj  blackouts
     :cljs (map (fn [blackout]
                  (-> blackout
                      (update :blackout/start-time date-util/to-tz timezone)
                      (update :blackout/end-time date-util/to-tz timezone)))
                blackouts)))


(def ^{:arglists '([blackout lang])} description
  (i18n-model/translation-fallback-fn :blackout/descriptions))


(defn applies-to-date? [date {:blackout/keys [start-time end-time]}]
  #?(:clj (and (or (= start-time date) (.before ^Date start-time ^Date date))
               (.before ^Date date ^Date end-time))
     :cljs (<= start-time date end-time)))
